module.exports = __webpack_public_path__ + "static/media/mvp_image.b0490d11.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/MobileApp/assets/mvp_image.png
// module id = 551
// module chunks = 0